import React from "react";

import { Button } from "components/ui/Button";
import { DialogFooter } from "components/ui/Dialog";

export const FormActions = ({
  onCancel,
  isSubmitting,
  isSubmitDisabled,
}) => {
  const isSaveDisabled = isSubmitDisabled || isSubmitting;

  return (
    <DialogFooter>
      <Button
        variant="outline"
        size="large"
        type="button"
        onClick={onCancel}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        size="large"
        type="submit"
        disabled={isSaveDisabled}
        data-testid="vaccine-save-button"
      >
        {isSubmitting ? "Saving..." : "Save"}
      </Button>
    </DialogFooter>
  );
};
